import {
  aYaraSource,
  aYaraSourcePage,
  mockYaraSourceDetailOperationQuery,
  mockYaraSourcesOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockYaraSourcesOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          yaraSources: aYaraSourcePage(),
        },
      });
    }
  ),
  mockYaraSourceDetailOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          yaraSource: aYaraSource(),
        },
      });
    }
  ),
];
